// extracted by mini-css-extract-plugin
export var attachment = "_ms-a";
export var emailContainer = "_ms-4";
export var emailContentPaddedContainer = "_ms-b";
export var emailHeader = "_ms-6";
export var emailIframe = "_ms-3";
export var emailInfoIcon = "_ms-9";
export var emailShortenedSummary = "_ms-e";
export var infoDropdown = "_ms-0";
export var infoRowBoundedContent = "_ms-d";
export var internal = "_ms-5";
export var merchant = "_ms-8";
export var messageInputContainer = "_ms-h";
export var normal = "_ms-7";
export var replyCard = "_ms-f";
export var subtleButton = "_ms-1";
export var subtleButtonIconContainer = "_ms-2";
export var toggleViewRepliesButton = "_ms-c";
export var wrappingText = "_ms-g";